import * as React from "react";
import { forwardRef } from "react";
const SvgArrowIncrease = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 9L7.41 10.41L11 6.83V21H13V6.83L16.59 10.42L18 9L12 3L6 9Z", fill: "#C4D9FF" }));
const ForwardRef = forwardRef(SvgArrowIncrease);
export { ForwardRef as ReactComponent };
